<div class="card">
    <div class="card-body">
        <h5>{{'Danh Sách Yêu Cầu Hoàn Hủy' | translate}}</h5>
        <div class="">
            <div class="row d-flex justify-content">

                <div class="form-group col-3">
                    <label for="validationCustom01">{{ 'Tên cửa hàng' | translate }}</label>
                    <input type="tel" class="form-control" [(ngModel)]="filter.full_name"
                        placeholder="Nhập tên cửa hàng" (change)="submitFilter()" />
                </div>
                <div class="form-group col-3">
                    <label for="validationCustom01">{{ 'Số điện thoại' | translate }}</label>
                    <input type="tel" class="form-control" [(ngModel)]="filter.phone" placeholder="Nhập số điện thoại"
                        (change)="submitFilter()" />
                </div>

                <div class="form-group col-3">
                    <label for="status">Trạng thái</label>
                    <ng-select [(ngModel)]="filter.status" [clearable]="true" (change)="submitFilter()"
                        placeholder="Tất cả trạng thái">
                        <ng-option value="">Tất cả</ng-option>
                        <ng-option value="pending">Chờ duyệt</ng-option>
                        <ng-option value="approved">Đã duyệt</ng-option>
                        <ng-option value="rejected">Từ chối</ng-option>
                    </ng-select>
                </div>

                <div class="form-group col-3">
                    <label for="validationCustom01">{{ 'Mã thiết bị' | translate }}</label>
                    <input type="text" class="form-control" [(ngModel)]="filter.serial_number"
                        placeholder="Nhập mã thiết bị" (change)="submitFilter()" />
                </div>


                <div class="form-group col-3">
                    <mat-form-field appearance="fill" class="mt-3">
                        <mat-label>Chọn khoảng ngày </mat-label>
                        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                            <input matStartDate formControlName="start" placeholder="Ngày bắt đầu" />
                            <input matEndDate formControlName="end" placeholder="Ngày kết thúc" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start
                            date</mat-error>
                        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-group col-3 btn-ok">
                    <div class="col-4">
                        <div style="min-width: 200px;">
                            <div class="form-group">
                                <button class="btn btn-primary" (click)="submitFilter()">
                                    {{'PAGE.REPORT.Search' | translate}}
                                </button>
                                <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">
                                    {{'FORM.Clear' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr class="bg-table">
                        <th>#</th>
                        <th class="col-quanly">{{ 'Quản lý' | translate }}</th>
                        <th>{{ 'Tên cửa hàng' | translate }}</th>

                        <th>{{ 'SĐT' | translate }}</th>
                        <th>{{ 'Mã thiết bị' | translate }}</th>
                        <th class="col-thang">{{ 'Loại TB' | translate }}</th>
                        <th>{{ 'Trạng thái' | translate }}</th>
                        <th class="col-thang">{{ 'Gói DV' | translate }}</th>
                        <th>{{ 'Số tiền' | translate }}</th>
                        <th>{{ 'Lý do hủy' | translate }}</th>
                        <th>{{ 'Ngày tạo yêu cầu' | translate }}</th>
                        <th>{{ 'Ngày kích hoạt' | translate }}</th>
                        <th>{{ 'Ngày hết hạn' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of listData; let i = index">
                        <td>{{ limit * (page - 1) + i + 1 }}</td>
                        <td>
                            <a *ngIf="data.status === 'pending'" class="font-size-14 text-success"
                                (click)="openCancelPopup(data)">
                                Xác nhận hủy
                            </a>
                        </td>
                        <td>{{ data.full_name }}</td>
                        <td>{{ data.phone }}</td>
                        <td>{{ data.serial_number }}</td>
                        <td>{{ data.order_device_type_name }}</td>
                        <td>
                            <span class="badge" [ngClass]="{
                             'badge-warning': data.status === 'pending',
                             'badge-success': data.status === 'approved',
                             'badge-danger': data.status === 'rejected'
                             }">
                                {{ statusMap[data.status] }}
                            </span>
                        </td>

                        <td>{{ data.order_duration }} tháng</td>
                        <td>{{ data.order_discounted_price }} <sup><ins>đ</ins></sup></td>
                        <td>{{ data.reason }}</td>
                        <td>{{ data.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td>{{ data.activation_date | date: 'dd/MM/yyyy' }}</td>
                        <td>{{ data.expiration_date | date: 'dd/MM/yyyy' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-2">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{'TABLE.Showing' | translate}} {{limit*page - limit + 1}}
                    {{'TABLE.to' | translate}} {{limit*page}} {{'TABLE.of' |
                    translate}} {{totalCount}} {{'TABLE.entries' | translate}}
                </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end">
                <div class="text-md-right float-md-right pagination-rounded">
                    <ngb-pagination [collectionSize]="totalCount" [(page)]="page" [pageSize]="limit" [maxSize]="5"
                        [ellipses]="true" (pageChange)="fetchData()">
                    </ngb-pagination>
                </div>
                <div class="dataTables_length ml-3" id="tickets-table_length">
                    <label class="d-inline-flex align-items-center mb-0">
                        {{'TABLE.Show' | translate}}
                        <select name="tickets-table_length" aria-controls="tickets-table" name="limit"
                            [(ngModel)]="limit" (ngModelChange)="page = 1;fetchData()"
                            class="custom-select custom-select-sm form-control form-control-sm mx-2">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="25">25</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                        </select>
                        {{'TABLE.entries' | translate}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="showCancelPopup" class="modal-backdrop">
    <div class="modal-content-custom">
        <div class="modal-header">
            <h5 class="modal-title">Hủy đơn hàng</h5>
            <button type="button" class="close" aria-label="Close" (click)="closeCancelPopup()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <div class="form-group mt-3">
                <label>Lý do hủy <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="cancelData.reason" disabled />
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-danger" (click)="confirmCancel('approved')">Xác nhận hủy</button>
            <button class="btn btn-warning" (click)="confirmCancel('rejected')">Từ chối</button>
        </div>
    </div>
</div>